/* eslint-disable react/prop-types */
import React, { useState, useEffect, useContext } from "react";
import Grid from "@mui/material/Grid";
// import Modal from "@mui/material/Modal";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import { Card, Icon } from "@mui/material";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { useNotification } from "context/notification.context";
import { addPricingGroup } from "network/service";




export default function AddEditPriceGroupPopup(props) {
    const { showNotification } = useNotification();
    const [loading, setLoading] = useState(false);
    const [newField, setNewField] = useState({ name: "" });

    const validate = () => {
        if (newField.name.trim() === "") {
            isValid = false;
        }
        return true;
    };

    const Create = async () => {

        if (validate()) {
            try {
                setLoading(true);
                await addPricingGroup({
                    name: newField.name
                });
                showNotification("success", "Success", "Pricing Group Created Successfully");
                props.handlesuccess();
            } catch (err) {
                console.log(err);
            } finally {
                setLoading(false);
            }
        }
    };

    return (

        <Dialog
            id="modal-display"
            open={props.isopen}
            aria-labelledby="form-dialog-title"
            aria-describedby="modal-modal-description"
            maxWidth="90%"
            maxHeight="90%"
            onClose={props.handleclose}
            disableBackdropClick
        >

            <Card sx={{}}>
                <MDBox  >
                    <DialogTitle>Add Pricing Group</DialogTitle>
                </MDBox>
                <DialogContent sx={{ minWidth: 500 }}>
                    <Grid container direction="column" spacing={2}>
                        <Grid item>
                            <Grid container spacing={1}>
                                <Grid item xs={12} md={12} xl={12}>
                                    <MDInput
                                        label="Group Name"
                                        value={newField.name}
                                        fullWidth

                                        onChange={(e) => {
                                            setNewField({
                                                ...newField,
                                                name: e.target.value.toUpperCase()
                                            });
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>

                    <MDButton variant="gradient" color="error" onClick={props.handleclose}
                        disabled={loading}>
                        <Icon>close</Icon>&nbsp;
                        Cancel
                    </MDButton>
                    <MDButton variant="gradient" color="success"
                        disabled={loading}
                        onClick={() => { Create() }}>
                        <Icon>save</Icon>&nbsp;
                        Save
                    </MDButton>
                </DialogActions>
            </Card>
        </Dialog>
    )
};
